import * as React from 'react';
import { Button, Modal } from '@ixicare/ui';
import { IndoorGeofencingMode } from '@ixicare/resources';
import { t } from '~i18n';
import { Spacer } from '~components/Utils/Spacer';

interface Props {
  // The polarity being switched to. The wording flips with it.
  to: IndoorGeofencingMode;
  selectedCount: number;
  invertedCount: number;
  // The complement is unknown until the site's zones have loaded.
  canInvert: boolean;
  onInvert: () => void;
  onKeep: () => void;
  onCancel: () => void;
}

// Switching polarity is never silent. The same list of rooms means the opposite thing afterwards,
// and which answer is right depends on what the carer meant, not on anything the form can infer.
export function InvertZonesModal({ to, selectedCount, invertedCount, canInvert, onInvert, onKeep, onCancel }: Props) {
  return (
    <Modal onClose={onCancel} style={{ maxWidth: 450 }}>
      <h3 className="text-center mb-10">{t('profile-configuration.geofence.invert.title')}</h3>
      <p className="mb-15">
        {t(
          to === IndoorGeofencingMode.Block
            ? 'profile-configuration.geofence.invert.toBlock'
            : 'profile-configuration.geofence.invert.toAllow',
          { zones: selectedCount }
        )}
      </p>
      <Spacer size={32} />
      <Button className="mb-15" isBlock type="button" disabled={!canInvert} onClick={onInvert}>
        {t('profile-configuration.geofence.invert.invert', { zones: invertedCount })}
      </Button>
      <Button className="mb-15" isBlock buttonType="link" onClick={onKeep}>
        {t('profile-configuration.geofence.invert.keep')}
      </Button>
      <Button isBlock buttonType="link" onClick={onCancel}>
        {t('global.cancel')}
      </Button>
    </Modal>
  );
}

export default InvertZonesModal;
